import { useState } from "react";
import Modal from "react-modal";
import { useSelector } from "react-redux";

import { SlideDetailState } from "shared/reducers/slideDetailReducer";
import { FeatureFlags } from "shared/reducers/sysReducer";

import Spinner from "components/Spinner";
import ApplicationState from "store/ApplicationState";

import { DialogEnum } from "./dialogs/Dialog";
import OSD from "./OSD";

interface SlideComponentProps {
  slideDetailObject: SlideDetailState;
  emptyCase: boolean;
  archived: boolean;
  setDialog: Function;
  dialog: DialogEnum | null;
  manuallyClosedDialog?: boolean;
}

export default function SlideComponent(props: SlideComponentProps) {
  const [requested, setRequested] = useState<Date | null>(null);
  const [retentionOpen, setRetentionOpen] = useState<boolean>(false);

  const features: FeatureFlags = useSelector(
    ({ sys }: ApplicationState) => sys.features
  );

  return (
    <>
      <div className="SlideOSD">
        {!props.slideDetailObject.loading ? (
          props.emptyCase ? (
            <div className="SlideOSD--missing">This case has no slides.</div>
          ) : props.archived ? (
            <div className="SlideOSD--missing">
              This slide is not available in storage.
              {features.slide_restoration_process && (
                <>
                  <button
                    onClick={() => setRetentionOpen(true)}
                    disabled={requested !== null}
                  >
                    {requested ? "Restoring Images..." : "Restore Images"}
                  </button>
                  {requested && <p>Requested {requested.toLocaleString()}</p>}
                </>
              )}
            </div>
          ) : (
            <OSD
              slideDetailObject={props.slideDetailObject}
              setDialog={props.setDialog}
              dialog={props.dialog}
              manuallyClosedDialog={props.manuallyClosedDialog}
            />
          )
        ) : (
          <Spinner />
        )}
      </div>
      <Modal
        isOpen={retentionOpen}
        onRequestClose={() => setRetentionOpen(false)}
        contentLabel="Flag Slide"
        className="Modal"
        overlayClassName="Overlay"
      >
        <h3>Slide Image Restoration</h3>
        <p>
          <span>Please allow up to 24 hours for slides to be restored.</span>
        </p>
        <button
          className="Button"
          onClick={() => {
            setRequested(new Date());
            setRetentionOpen(false);
          }}
        >
          Restore Images
        </button>
      </Modal>
    </>
  );
}
